import { render, staticRenderFns } from "./Segmento.vue?vue&type=template&id=2f09ab14&scoped=true"
import script from "./Segmento.vue?vue&type=script&lang=js"
export * from "./Segmento.vue?vue&type=script&lang=js"
import style0 from "./Segmento.vue?vue&type=style&index=0&id=2f09ab14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f09ab14",
  null
  
)

export default component.exports